import Headroom from 'headroom.js'
import { debounce } from 'lodash'
import $ from 'jquery'


export default function initHeadroom() {
  var $header = $('#headroom')
  if ($header.length === 0) {
    return
  }
  const navbarEl = $('.navbar--bsf')
  const indexEl = $('.index-container__index')

  const updateBodyPadding = () => {
    $('body').css('paddingTop', navbarEl.outerHeight() + (indexEl.outerHeight() || 0))
  }
  const updateHeaderOnScroll = () => {
    if (window.pageYOffset === 0) {
      $header.removeClass('slideDown slideUp')
    }
    //console.log('updateHeaderOnScroll')
  }
  const onScroll = () => {
    updateHeaderOnScroll()
    window.setTimeout(updateHeaderOnScroll, 200)
  }
  updateBodyPadding()
  window.addEventListener('scroll', debounce(onScroll, 100))
  //init headroom
  const headroom  = new Headroom($header.get(0), {
    offset: $header.height(),
    tolerance : 15,
    'classes': {
      'initial': 'header--fixed',
      'pinned': 'slideDown',
      'unpinned': 'slideUp',
      'top': 'top',
      'notTop' : 'not-top',
    }
  })
  headroom.init()
  // update body padding top when resized
  window.addEventListener('resize', updateBodyPadding, false)

  $('#navbarSupportedContent').on('hidden.bs.collapse', updateBodyPadding)
}

